'use strict';

import {gsap} from 'gsap';

const $ = jQuery.noConflict();
$(function() {

	const sponsors = {

		init: function() {
			this.cacheDOM();
			this.initMarquee();
		},

		cacheDOM: function() {
			this.$sliders = $('.js-sponsors-slider');
		},

		initMarquee: function() {
			this.$sliders.each(function() {
				const $track = $(this);
				const $original = $track.find('.js-sponsors-items');

				if (!$original.length) return;

				// Wait for all images to load before measuring widths
				const $images = $original.find('img');
				let loaded = 0;
				const total = $images.length;

				if (!total) {
					sponsors.startMarquee($track, $original);
					return;
				}

				$images.each(function() {
					if (this.complete) {
						loaded++;
						if (loaded >= total) sponsors.startMarquee($track, $original);
					} else {
						$(this).on('load error', function() {
							loaded++;
							if (loaded >= total) sponsors.startMarquee($track, $original);
						});
					}
				});
			});
		},

		startMarquee: function($track, $original) {
			const itemsWidth = $original[0].offsetWidth;

			// Clone until total width covers at least 2x the viewport
			const clonesNeeded = Math.ceil((window.innerWidth * 2) / itemsWidth);

			for (let i = 0; i < clonesNeeded; i++) {
				$track.append($original.clone());
			}

			// Animate each item wrapper using pixel value
			const duration = 30;

			$track.find('.js-sponsors-items').each(function() {
				gsap.to(this, {
					x: -itemsWidth,
					repeat: -1,
					duration: duration,
					ease: 'linear'
				});
			});
		},

	};

	sponsors.init();
});
